module.exports = __webpack_public_path__ + "static/media/12.2d5fb9f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/12.png
// module id = 378
// module chunks = 0